export const dataset = "ishavskraft-001";
export const projectId = "n5xeg4df";
export const apiVersion = "2024-03-15";
